module.exports = {"330213001":"锦屏街道","330213002":"岳林街道","330213003":"江口街道","330213004":"西坞街道","330213005":"萧王庙街道","330213006":"方桥街道","330213007":"尚田街道","330213008":"莼湖街道","330213100":"溪口镇","330213106":"裘村镇","330213107":"大堰镇","330213108":"松岙镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330213.json
// module id = 1063
// module chunks = 0